import * as React from 'react';
export const MMSvg = React.forwardRef(function MMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 6V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'm10.755 7-1.75.004a.243.243 0 0 1-.231-.168L8.232 5.17a.243.243 0 0 0-.464 0l-.54 1.664a.243.243 0 0 1-.231.168H5.246a.243.243 0 0 0-.143.441l1.415 1.03a.243.243 0 0 1 .089.272l-.54 1.665a.243.243 0 0 0 .375.272l1.415-.95a.243.243 0 0 1 .287 0l1.416.95a.243.243 0 0 0 .376-.272l-.542-1.665a.243.243 0 0 1 .088-.273l1.416-1.029A.246.246 0 0 0 10.755 7Z',
      }),
    ),
  );
});
MMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MM = {
  category: 'flag',
  colorable: false,
  name: 'MM',
  svg: MMSvg,
};
